export default function Footer() {
  return (
    <footer style={styles.footer}>
      <p>© 2025 Hungry King | Crafted with elegance & spice</p>
    </footer>
  );
}

const styles = {
  footer: {
    marginTop: '2rem',
    backgroundColor: '#03045e',
    color: 'white',
    textAlign: 'center',
    padding: '1rem',
  }
};
